import { useState, useEffect } from 'react';

interface User {
  id: string;
  email: string;
  name?: string;
  created_at: string;
  updated_at: string;
}

interface UseCurrentUserReturn {
  user: User | null;
  loading: boolean;
  error: string | null;
}

export const useCurrentUser = (): UseCurrentUserReturn => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getTokenFromCookies = () => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'sgo_access_token') {
        return value;
      }
    }
    return null;
  };

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const token = getTokenFromCookies();
        if (!token) {
          setError('Token de autenticação não encontrado');
          setLoading(false);
          return;
        }

        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3030';
        const response = await fetch(`${API_BASE_URL}/users/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          setUser(data.data || data);
        } else if (response.status === 401) {
          // Token inválido ou expirado, redirecionar para login
          window.location.href = '/signin';
        } else {
          setError('Erro ao buscar dados do usuário');
        }
      } catch (err) {
        setError('Erro ao conectar com a API');
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  return {
    user,
    loading,
    error
  };
};